import React, {useState, useEffect} from "react"
import {Div, Tag, Text, Input, Label, Switch, Textarea, Icon, Notification} from "atomize";
import styled, {createGlobalStyle} from "styled-components";
import theme from "../../../Theme/Theme";
import ReactModal from 'react-modal';
import {ReactComponent as CloseIcon} from "../../../Assets/Icons/close.svg";
import { useScrollPosition } from './../../../utils/getScrollPosition';
import {PrimaryButton} from "../../Atoms/Button";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import {captchaKey} from "../../../Constants/constants";

const GlobalStyle = createGlobalStyle`
  .description p {
    padding: 1rem 0;
  }
  .ReactModal__Content--after-open {
      width: 800px;
      min-height: calc(100vh / 2);
      
      left: unset !important;
      right: unset !important;
      bottom: unset !important;
      border: none !important;
      
      padding: 2rem !important;
      
      @media (min-width: 881px) {
       max-height: calc(100vh - 8.5rem);
      }
      
      @media (max-width: 880px) {
        width: unset;
        top: 20px !important;
        left: 20px !important;
        right: 20px !important;
        bottom: 20px !important;
        padding: 1rem !important;
      }
    }
    .ReactModal__Overlay.ReactModal__Overlay--after-open {
      z-index: 200;
    }
    .ReactModal__Overlay {
      background-color: #009bdf6b !important;
      display: flex;
      justify-content: center;
      opacity: 0;
      .ReactModal__Content {
        transform: scale(0);
        transition: transform 250ms ease-in-out;
      }
      transition: opacity 250ms ease-in-out;
    }
    
    .ReactModal__Overlay--after-open{
      .ReactModal__Content {
        transform: scale(1);
      }
        opacity: 1;
    }
    
    .ReactModal__Overlay--before-close{
      .ReactModal__Content {
        transform: scale(0);
      }
      opacity: 0;
    }
    
    // .ReactModal__Body--open {
    //    overflow: hidden;
    // }
`;

const CloseButton = styled.a`
  position: absolute;
  padding: 1rem;
  top: .5rem;
  right: .5rem;
`;

const Wrapper = styled.div`
  p {
    font-family: Inter;
    font-size: 14px;
    color: #4E5D78;
    letter-spacing: 0;
    line-height: 24px;
    margin-bottom: 1.5rem;
  }
  input, #publish, textarea{
    margin-bottom: 1.5rem;
    margin-top: .5rem;
  }
  //.primary-wrapper {
  //  float: right;
  //  display: inline-flex;
  //}
  .__react_component_tooltip.place-top {
    margin-top: 10px;
  }
`;

const BtnWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

const Title = styled.h2`
  color: ${theme.colors.dark};	
  font-family: Inter;
  font-size: 24px;
  color: #0A1F44;
  letter-spacing: 0;
  line-height: 36px;
  margin: 0 2rem 1rem 0;
  font-weight: 600;
  @media (max-width: 880px) {
    margin: 2rem 0 1rem 0;
    font-size: 20px;
    line-height: 32px;
  }
`;

function getParent() {
  return document.querySelector('#root');
}

function ShareStoryModal(props) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [org, setOrg] = useState("");
  const [publish, setPublish] = useState(true);
  const [intro, setIntro] = useState("");
  const [valid, setValid] = useState(false);
  const [captcha, setCaptcha] = useState(false);
  const [success, setSuccess] = useState(false);

  useScrollPosition(({ prevPos, currPos }) => {
    if (props.open) {
      if ( Math.abs(prevPos.y - currPos.y) > 50 ) {
        props.close()
      }
    }
  }, [props.open]);

  useEffect(() => {
    ReactModal.setAppElement('#main');
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      setValid(true);
    } else {
      setValid(false);
    }
  }, [email]);

  const submit = () => {
    axios.get(`/share/story?name=${name}&email=${email}&org=${org}&publish=${publish.toString()}&intro=${intro}`)
      .then(function (response) {
        // handle success
        // console.log(response);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .then(function () {
        // always executed
        setSuccess(true);
        props.close();
      });
  };


  return (
    <>
      <GlobalStyle/>
      <Notification
        bg="success700"
        isOpen={success}
        onClose={() => setSuccess(false)}
        prefix={
          <Icon
            name="Success"
            color="white"
            size="18px"
            m={{ r: "0.5rem" }}
          />
        }
      >
        Thanks for submitting your story.
      </Notification>
      <ReactModal
        isOpen={props.open}
        shouldCloseOnOverlayClick={true}
        onRequestClose={() => props.close()}
        parentSelector={getParent}
        closeTimeoutMS={250}
        data={{
          background: "green"
        }}
      >
        <CloseButton
          aria-label={'close'}
          tabIndex={0}
          onClick={() => props.close() }
        >
          <CloseIcon/>
        </CloseButton>
        <Wrapper>
          <Title>Share your story</Title>
          <p>We welcome your stories of use and adaptation of Engineering for Humanity materials, whether it’s a small inspiration or a large-scale adaptation. You may share a story with us below, or by <a href={'mailto:E4H@Olin.edu'} >email</a>. We’ll reach out to you and may ask your permission to show it on our website!</p>
          <label
            htmlFor={'name'}
          >What's your name?</label>
          <Input
            id={'name'}
            placeholder={'Please tell us your name'}
            value={name}
            onChange={e => setName(e.target.value)}
          />
          <label
            htmlFor={'name'}
          >How do we contact you?</label>
          <Input
            id={'email'}
            placeholder={'Please leave us an email address'}
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <label
            htmlFor={'org'}
          >What’s your organization?</label>
          <Input
            id={'org'}
            placeholder={'E.g. Olin College of Engineering'}
            value={org}
            onChange={e => setOrg(e.target.value)}
          />
          <label
            htmlFor={'publish'}
          >May we publish your story on this site?</label>
          <Label
            onClick={() =>
              setPublish(!publish)
            }
            align="center"
            textWeight="600"
            m={{ b: "1rem" }}
            id={'publish'}
          >
            <Switch
              checked={publish}
            />
            { publish ? 'Please do!' : 'No thank you' }
          </Label>
          <label
            htmlFor={'details'}
          >
            Tell us more!
          </label>
          <Textarea
            placeholder="Please give us an introduction to your project. We will be in touch for more information shortly."
            value={intro}
            onChange={e => setIntro(e.target.value)}
          />
          <div style={{height: "78px", width: "100%", display: "block", marginBottom: '1px'}}>
            <ReCAPTCHA
              sitekey={captchaKey}
              onChange={onChange => setCaptcha(true)}
            />
          </div>
          <BtnWrapper>
            <PrimaryButton
              type={'button'}
              icon={'Email'}
              text={'Submit your story'}
              disabled={!valid || !captcha}
              action={() => submit()}
              tip={!valid ? "Invalid email address" : !captcha ? "Please check I'm not a robot" : null }
              tipPos={"top"}
            />
          </BtnWrapper>
        </Wrapper>
      </ReactModal>
    </>
  )
}

export default ShareStoryModal
